import { Outlet } from "react-router-dom";
import { useI18n } from "@/locales/i18n-provider";
import { AppShell } from "@/surfaces/standalone/layouts/app-shell";
import { WorkspaceSidebar } from "@/surfaces/standalone/layouts/workspace/sidebar";

export function WorkspaceLayout() {
  const { t } = useI18n();

  return (
    <AppShell navigationTitle={t("shell.workspaceNavigation")} renderSidebar={(options) => <WorkspaceSidebar {...options} />}>
      <Outlet />
    </AppShell>
  );
}
